import React from "react";
import { cardClasses, cardStatus } from "@/helpers/style.helpers";
import { ReadyToSendApiResponse } from "@/features/scanners/types";
import { beepOk, beepWarning } from "@/features/scanners/helpers";
import { Bin } from "@/types";

interface ComponentProps {
  data: Partial<ReadyToSendApiResponse> | null;
  bin: Bin;
}

const ContentComponent: React.FC<ComponentProps> = ({ data, bin }) => {
  if (!data) {
    return (
      <>
        Scan 1 of meerdere zakken in bak <span className="whitespace-nowrap font-bold">{bin?.name}</span>
      </>
    );
  }

  const { message } = data;
  const orderbagSequence = data?.sequence || "";

  switch (message) {
    case "BINS_DO_NOT_MATCH": //
      return (
        <div className="flex flex-col items-center justify-center">
          <div>Fout: Verkeerde bak!</div>
          <div>Zak: {orderbagSequence}</div>
        </div>
      );

    case "ORDERS_DO_NOT_MATCH": //
      return <>Fout: Verkeerde herstellingen!</>;

    case "ORDER_BAG_NOT_FOUND": //
      return <>Zak niet gevonden</>;

    case "ORDER_NOT_FOUND": //
      return null;

    case "INVALID_BARCODE_DATA": //
      return <>Ongeldige barcode</>;

    case "INCORRECT_ORDER_BAG_STATUS": //
      return <>Verkeerde zak status</>;

    default:
      if (orderbagSequence) {
        return <>Zak: {orderbagSequence}</>;
      }
      return null;
  }
};

export const Card: React.FC<ComponentProps> = (props) => {
  let className = "";
  const { data } = props;

  if (data) {
    switch (data.message) {
      case "ORDER_NOT_FOUND": //
      case "ORDER_BAG_NOT_FOUND": //
      case "BINS_DO_NOT_MATCH": //
      case "ORDERS_DO_NOT_MATCH": //
      case "INVALID_BARCODE_DATA":
      case "INCORRECT_ORDER_BAG_STATUS": //
        className = cardStatus.error;
        beepWarning();
        break;
      default:
        if (data.readyToSendAt) {
          className = cardStatus.info;
          beepOk();
        } else {
          className = cardStatus.neutral;
        }
    }
  } else {
    className = cardStatus.neutral;
  }

  return (
    <div className={`${cardClasses} ${className} w-full m-5`}>
      <div className="flex flex-col items-center justify-center">
        {typeof data?.readyToSendAt === "string" && <div className="m-4 font-semibold">OK</div>}
        <ContentComponent {...props} />
      </div>
    </div>
  );
};
